module.exports = __webpack_public_path__ + "img/icons-24-setting.19d92120.svg";